import React, { useEffect, useState } from 'react';
import { LoadingScreen, Dialog } from '@next-common/mui';
import { useBreakpoint } from '@next-common/breakpoint';
import { TabsPayment } from './components/TabsPayment/TabsPayment';
import ACTIONS from '../../modules/actionTypes';
import { useDispatch, useSelector } from 'react-redux';
import { callFloa, callKlarna } from '../../modules/actions';
import Box from '@mui/material/Box';
import * as s from './PaymentMeanDetails.style';
export const PaymentMeanDetailsModalV5 = ({ paymentMethods = [], isEligibleToKlarna = false, isEligibleToFloa10x = false, isEligibleToPaypal4x = false, price = 0, extraClassName = "_hy" }) => {
    const dispatch = useDispatch();
    const paymentMeanDetailsModalState = useSelector((state) => state.paymentMeanDetailsModal);
    const loader = (klarna, floa) => {
        return klarna && floa;
    };
    const [isLoading, setIsLoading] = useState(!loader(paymentMeanDetailsModalState.isFloaLoaded, paymentMeanDetailsModalState.isKlarnaLoaded));
    const onCloseCallBack = () => {
        dispatch({ type: ACTIONS.HIDE });
    };
    useEffect(() => {
        setIsLoading(!loader(paymentMeanDetailsModalState.isKlarnaLoaded, paymentMeanDetailsModalState.isFloaLoaded));
    }, [
        paymentMeanDetailsModalState === null || paymentMeanDetailsModalState === void 0 ? void 0 : paymentMeanDetailsModalState.isKlarnaLoaded,
        paymentMeanDetailsModalState.isFloaLoaded,
    ]);
    useEffect(() => {
        if (isEligibleToPaypal4x)
            paymentMethods.push({
                name: 'PAYPAL',
                monthlyPayment: 4,
                simulationUrl: '',
            });
        if (isEligibleToKlarna) {
            dispatch(callKlarna(price));
        }
        if (isEligibleToFloa10x) {
            dispatch(callFloa(price));
        }
    }, []);
    const { md } = useBreakpoint();
    const isMobile = md.mobile && !md.isEmbeddedInBuyerApp ? true : false;
    return (React.createElement(Dialog, { withFullWidthBody: true, withCloseIcon: true, dataQa: 'paymentMeanDetailsModal', PaperProps: { sx: s.paper(isMobile) }, onClose: () => onCloseCallBack(), open: true, title: React.createElement(Box, { sx: { display: 'flex', justifyContent: 'center', width: '100%' } },
            React.createElement(Box, { sx: { fontSize: '16px' } }, "Payer en plusieurs fois.")) }, isLoading ? (React.createElement(LoadingScreen, null)) : (React.createElement(TabsPayment, { paymentMethods: paymentMethods }))));
};
